module.exports = __webpack_public_path__ + "img/Skull_Earring.07207fb8.png";